<template>
  <div>
    <layout />

    <eligibility-error-modal
      v-if="isEligibilityErrorModalOpen"
      :availity="clientEligibilityConfigs.availity"
      @close="closeEligibilityErrorModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import eligibilityService from '@/services/EligibilityService';
import registerAccountService from '@/services/RegisterAcccountService';
import EligibilityErrorModal from '@/components/forms/eligibility-form/EligibilityErrorModal.vue';

// COMPONENTS
import Layout from '@/components/layout/Layout.vue';
import { clientStoreTypes } from '@/store/types';

export default {
  name: 'Registration',

  components: {
    Layout,
    EligibilityErrorModal,
  },

  provide() {
    return {
      $registration: {
        getEligibilityAlreadyTried: () => this.eligibilityAlreadyTried,
        openEligibilityErrorModal: this.openEligibilityErrorModal,
        setEligibilityAlreadyTried: this.setEligibilityAlreadyTried,
      },
    };

  },

  data() {
    return {
      eligibilityAlreadyTried: false,
      isEligibilityErrorModalOpen: false,
    };
  },

  computed: {
    ...mapGetters({
      clientEligibilityConfigs: clientStoreTypes.getters.GET_CLIENT_ELIGIBILITY_CONFIGS,
    }),
  },

  beforeDestroy() {
    eligibilityService.resetData();
    registerAccountService.resetData();
  },

  methods: {
    setEligibilityAlreadyTried(value) {
      this.eligibilityAlreadyTried = value;
    },
    openEligibilityErrorModal() {
      this.isEligibilityErrorModalOpen = true;
    },
    closeEligibilityErrorModal() {
      this.isEligibilityErrorModalOpen = false;
    },
  },
};
</script>
